// @flow
import React from "react";

type Props = {
  src: string
};

const CoverPic = ({ src }: Props) => {
  return (
    <div
      style={{
        background: `url('${src}') no-repeat center center`,
        backgroundSize: "cover",
        height: 300
      }}
    />
  );
};

export default CoverPic;



// WEBPACK FOOTER //
// ./src/commons/CoverPic.js